import React, { useState } from 'react'
import { useFormik } from 'formik'
import './style.css'
import CustomizedBoldText from '../../components/CustimizedBoldText'
import CustomizedMediumText from '../../components/CustomizedMediumText'
import CustomizedButton from '../../components/CustomizedButton'
import { logInInitialValues, loginSchema } from '../../utils/formikSchemas'
import { useDispatch } from 'react-redux'
import { resetPasswordFirstCall } from '../../redux/actions/userActions'
import SSLLogo from '../../Images/SSLLogo'
import Navigator from '../../components/Navigator'

const ForgetPassword = () => {
  //states
  const [submitPressed,setSubmitPressed] = useState(false)

  // redux handlers
  const dispatch = useDispatch()

  const formik = useFormik({
    initialValues: logInInitialValues,
    validationSchema:loginSchema,
    onSubmit: (values) => {
      dispatch(resetPasswordFirstCall({user_name:values.email}))

    },
  })

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    values,
    errors,
  } = formik

  return (
    <div className='signIn-container'>
      <div className='signIn-form'>
        <SSLLogo/>
        <div className='signIn-logo'>
          <img src={require('../../Images/motivatonLogo.png')} alt="LOGO" />
          <CustomizedBoldText text={'Reset password'} fontSize={40} lineHeight={'53px'}/>
          <CustomizedMediumText text={'Please enter your details.'} 
            fontSize={20} 
            lineHeight={'27px'} 
            textAlign={'center'}
            color={'#838383'}
          />
        </div>
        <form onSubmit={handleSubmit}>
          <div>
            <CustomizedMediumText text={'Email'} fontSize={16} lineHeight={'24px'}/>
            <input
              type="email"
              name="email"
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder='Enter your email'
              className={(submitPressed && errors.email ) ? 'inputError' : null}
            />
            {submitPressed && errors.email ? (
              <div className="error">{errors.email}</div>
            ) : null}
          </div>
          <CustomizedButton 
            marginTop={16}
            title={'Continue'}
            color={'#ffffff'}
            onClick={() => {
              setSubmitPressed(true)
              handleSubmit()
            }}
          />
          <div className='loginLink'>
            <CustomizedMediumText text={'Already have an account?'} 
              fontSize={16} 
              lineHeight={'21px'} 
              textAlign={'center'}
              color={'#838383'}
            />
            <Navigator screen={'/signup'}><span className='link'>Sign Up</span></Navigator>
          </div>
        </form>
      </div>
    </div>
  )
}


export default ForgetPassword